(function () {
    'use strict';

    angular.module('swif.openbase')
        .factory('swifOpenbaseCompanyService', swifOpenbaseCompanyService);

    function swifOpenbaseCompanyService($q, swif) {
        'ngInject';
        var service = {};

        service.getCompany = function (){
            // we have only one company per db now
            // 1 -> company id

            return swif.data.get('res_company', 1).then(function(company) {
                return company;
            });
        };

        service.getCompanyCurrencySymbol = function(){

            var params = {
                fields: ['currency_id']
            };

            return swif.data.get('res_company', 1, params).then(function(currencySymbol){
                return currencySymbol;
            });
        }

        service.getCurrencySymbol = function(){

            return service.getCompanyCurrencySymbol().then(
                function(company) {
                    if(company.currency_id){
                        // Extract the currency symbol
                        var currencyId = company.currency_id[1];
                        var currencySymbol = currencyId.substring(currencyId.lastIndexOf("(") + 1,currencyId.lastIndexOf(")"));

                        return currencySymbol;
                    }else{
                        return '';
                    }
            });
        };

        service.formatCurrency = function (value){

            return service.getCurrencySymbol().then(
                function(currencySymbol){

                    var cost;

                    if(!value){
                        value = '0,00';
                    }

                    if(currencySymbol=="£"){
                        cost = currencySymbol + ' ' + value;
                    } else {
                        cost = value + ' ' + currencySymbol;
                    }

                    return cost;

                }
            );
        }

        service.getGlobalSettings = function (){
            // we have only one company per db now
            // we use it to save global settings
            // 1 -> company id
            var filter = {fields: ['task_default_hours', 'task_default_report_hours',
                'intervention_window_synchronize_status', 'add_intervention_window_create_task',
                'task_patrimony_tab_enable','task_patrimony_tab_required', 'task_notify', 'task_notify_default_value',
                'add_task_window_advanced_mode','validate_request_window_advanced_mode', 'task_purchase_order_default_value',
                'task_in_validate_request_window_advanced_mode','task_in_create_intervention_window_advanced_mode',
                'request_priority_require', 'request_priority_enable', 'request_communication_channel_enable',
                'request_communication_channel_require', 'request_report_date_enable', 'request_report_date_replace',
                'project_template_enable','project_ask_template_require', 'task_range_enable', 'state_default_filters',
                'request_note_enable', 'processing_times_enable', 'project_ask_template_require']};

            return swif.data.get('res_company', 1, filter).then(function(company) {
                return company;
            });
        };

        service.getGlobalSettingsPurchases = function (){
            var filter = {fields: ['enable_purchase_order', 'enable_purchase_order_ask', 'default_consumables_req_state',
                'default_po_state', 'default_warehouse_id', 'default_budget_id', 'use_pump_stock_value',
                'force_all_purchase_order_to_be_sent_to_civil', 'default_value_sent_to_civil']};
            return swif.data.get('res_company', 1, filter);
        };

        service.getGlobalSettingsResa = function (){
            var filter = {fields: ['discountResa']};
            return swif.data.get('res_company', 1, filter);
        };

        service.saveCompany = function (company) {
            // we have only one company per db now
            // we use it to save global settings
            // 1 -> company id
            swif.data.save('res_company', 1, company).then(function () {
                swif.message.addInfo('save ok');
            }, function (error) {
                swif.message.addError(error);
            });
        };

        /**
         * Returns HTML data of legals page
         */
        service.getLegals = function() {
            // Permit unauthorized access with "public" set to true
            const options = {public: true};
            return swif.route.check(options).then(function () {
                var ret = $q.defer();
                var http = {
                    url: '/web/user/legals',
                    params: {
                        db: swif.settings.app.db
                    }
                }
                swif.data.post(undefined, http).then(function(legals) {
                    ret.resolve(legals);
                });
                return ret.promise;
            });
        };

        return service;
    }

})();
